import {
  LoadingOutlined
} from '@ant-design/icons';
import { Flex, Spin } from 'antd';
import { Route, Routes } from "react-router-dom";
import { useLoading } from "../contexts/LoadingContext";
import Usuarios from "../views/Administrativo/Usuarios";
import Bancario from '../views/Demandas/bancario';
import Civil from "../views/Demandas/civil";
import Consumidor from "../views/Demandas/consumidor";
import Familia from "../views/Demandas/familia";
import Geral from "../views/Demandas/geral";
import FormCliente from "../views/Demandas/geral/FormCliente";
import TelaCliente from "../views/Demandas/geral/TelaCliente";
import Imobiliario from "../views/Demandas/Imobiliario";
import Previdenciario from "../views/Demandas/previdenciario";
import Trabalhista from "../views/Demandas/trabalhistaView";
import InfoInicio from "../views/InfoInicio";


export default function PagesRoutes() {
  const { loading } = useLoading();

  return (
    <>
      {loading &&
        <div className="full-screen-loading">
          <Flex align="center">
            <Spin indicator={<LoadingOutlined style={{ fontSize: 56 }} spin />} />
          </Flex>
        </div>
      }
      <div className='work-area'>
        <Routes>
          <Route path="/inicio" element={<InfoInicio />} />
          <Route path="/demandas/geral" element={<Geral />} />
          <Route path="/demandas/consumidor" element={<Consumidor />} />
          <Route path="/demandas/civil" element={<Civil />} />
          <Route path="/demandas/trabalhista" element={<Trabalhista />} />
          <Route path="/demandas/imobiliario" element={<Imobiliario />} />
          <Route path="/demandas/familia" element={<Familia />} />
          <Route path="/demandas/previdenciario" element={<Previdenciario />} />
          <Route path="/demandas/geral/new" element={<FormCliente />} />
          <Route path="/demandas/geral/cliente/:idCliente" element={<TelaCliente />} />
          <Route path="/demandas/bancario" element={<Bancario />} />
          <Route path="/administrativo/usuarios" element={<Usuarios />} />
        </Routes>
      </div>
    </>
  )
}
